import { RequirementReviewStrategy } from "@wingspanhq/payments/dist/interfaces/requirement";

export const selectorIsReviewStrategyApproval = (
  reviewStrategy: RequirementReviewStrategy | undefined
) => {
  return (
    reviewStrategy === RequirementReviewStrategy.AlwaysRequired ||
    reviewStrategy === RequirementReviewStrategy.OnFail
  );
};
